module.exports = __webpack_public_path__ + "static/media/Optiflo.0bd92762.pdf";